import {gql} from '@apollo/client';

export const USED_INVENTORY_DATA = gql`
  query UsedInventoryData(
    $zipcode: String!
    $distance: Int!
    $pageSize: Int!
    $pageNumber: Int!
    $sortBy: String!
    $filters: String!
    $mapsUrlTemplate: String
  ) {
    usedInventory: getUsedPagedInventoryByZipAndDistanceAndFilters(
      zipcode: $zipcode
      distance: $distance
      pageSize: $pageSize
      pageNumber: $pageNumber
      sortBy: $sortBy
      filters: $filters
      mapsUrlTemplate: $mapsUrlTemplate
    ) {
      totalPages
      totalVehicles
      vehicles {
        adjustedListPrice
        dealerDeeplink
        dealerEnrollmentStatusInd
        dealerProvider
        engineDescription
        exteriorColorDescription
        factoryExteriorCode
        factoryInteriorCode
        interiorColorDescription
        mediaImageUrl
        model
        modelCode
        modelYear
        mpgCity
        mpgHighway
        msrp
        odometer
        onlineSalesURL
        subTrimLevel
        trimLevel
        usedType
        vin
        dealer {
          address1
          address2
          city
          dealerid
          distance
          name
          phone
          postalcode
          state
          url
        }
      }
      dealers {
        address1
        address2
        city
        dealerid
        distance
        name
        phone
        postalcode
        state
        url
      }
      closestDealer {
        address1
        address2
        city
        dealerid
        distance
        name
        phone
        postalcode
        state
        staticMapsUrl
        url
      }
      filter {
        filterAttributes {
          models {
            key
            value
          }
          transmissionType {
            key
            value
          }
          exteriorColor {
            key
            value
          }
          interiorColor {
            key
            value
          }
          modelYear {
            key
            value
          }
          dealers {
            key
            value
          }
          models {
            key
            value
          }
          fuelType {
            key
            value
          }
        }
      }
    }
  }
`;
